import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token if present (for test/dev auth)
api.interceptors.request.use((config) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("tt_token") : null;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
